const getQueryParamOverride = param => {
    let queryParamOverride;
    if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
        const params = new URLSearchParams(location.search);
        const queryParam = params.get(param);
        if (queryParam) {
            queryParamOverride = queryParam.toLowerCase() === 'true';
        };
    }
    return queryParamOverride;
}

export default getQueryParamOverride;
